import useAppStatusStore from "./useAppStatusStore";
import usePlatformStore from "./usePlatformStore";

/**
 * Composable to expose information about how to render the default layout based on the query parameters and the platform configuration
 */
export const useLayout = () => {
  const route = useRoute();

  const appStatusStore = useAppStatusStore();
  const platformStore = usePlatformStore();

  onMounted(() => {
    if (!appStatusStore.getIsLayoutDisabled) {
      appStatusStore.setIsLayoutDisabled(route.query.layout === "false");
    }

    appStatusStore.setUsesDarkTheme(route.query.theme === "dark");
  });

  // Only allow setting of layout disabled if the url does not already contain this.
  // This way we can control the layout disabled from the inside if needed without intervening
  // when it's actually set from the outside
  const onSetIsLayoutDisabled = (isLayoutDisabled: boolean) => {
    if (route.query.layout !== "false") {
      appStatusStore.setIsLayoutDisabled(isLayoutDisabled);
    }
  };

  const isLayoutDisabled = computed(() => appStatusStore.getIsLayoutDisabled);
  const usesDarkTheme = computed(() => appStatusStore.getUsesDarkTheme);

  const { getStyleFromTheme } = useGetStyleFromTheme();
  const platformStyles = computed(() => {
    return getStyleFromTheme(
      platformStore.getPlatformConfiguration.styling,
      usesDarkTheme.value ? { overwriteTheme: "dark" } : undefined,
    );
  });

  return {
    /**
     * To be able to render a bare-bones version of the page.
     * Mainly meant to be used by the Native app to render the web page for some routes
     */
    isLayoutDisabled,
    setIsLayoutDisabled: onSetIsLayoutDisabled,
    platformStyles,
  };
};
